import { trimValues } from 'src/utils/common';
import { FilterOptionsType } from '../types/usersListType';
import { getLocLabel } from 'src/features/CallDocuments/utils/callDocumentHelperFunctions';
import { getColumnFromId } from 'src/utils/filterHelper';
import { sortOptions } from './userConstants';

export function createPayload(filterOptions: FilterOptionsType): any {
  return {
    draw: '1',
    timezoneOffset: `${new Date().getTimezoneOffset()}`,
    columns: [
      {
        data: 'UserName',
        name: '',
        searchable: true,
        orderable: true,
        search: {
          regex: false,
          value: filterOptions?.userName
            ? trimValues(filterOptions.userName)
            : '',
        },
      },
      {
        data: 'LastName',
        name: '',
        searchable: true,
        orderable: true,
        search: {
          regex: false,
          value: filterOptions?.lastName
            ? trimValues(filterOptions.lastName)
            : '',
        },
      },
      {
        data: 'FirstName',
        name: '',
        searchable: true,
        orderable: true,
        search: {
          regex: false,
          value: filterOptions?.firstName
            ? trimValues(filterOptions.firstName)
            : '',
        },
      },
      {
        data: 'AccountPIDs',
        name: '',
        searchable: true,
        orderable: true,
        search: {
          regex: false,
          value: filterOptions?.pid ? trimValues(filterOptions.pid) : '',
        },
      },
      {
        data: 'AccountCIDs',
        name: '',
        searchable: true,
        orderable: true,
        search: {
          regex: false,
          value: filterOptions?.cid ? trimValues(filterOptions.cid) : '',
        },
      },
      {
        data: 'Permissions',
        name: '',
        searchable: true,
        orderable: true,
        search: {
          regex: false,
          value: filterOptions?.permission
            ? getLocLabel(filterOptions.permission) || null
            : null,
        },
      },
      {
        data: 'Status',
        name: '',
        searchable: true,
        orderable: true,
        search: {
          regex: false,
          value: filterOptions?.status
            ? getLocLabel(filterOptions.status) || null
            : null,
        },
      },
    ],
    order: [
      {
        column: getColumnFromId(filterOptions.sortType, sortOptions),
        dir: filterOptions.sortOrder,
      },
    ],
    search: {
      value: trimValues(filterOptions.keywordSearch),
      regex: false,
    },
  };
}
